import React from 'react';
import { Layout, Result, Button, Typography, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import KasakaLogo from '../svg/kasaka';
import MojafinLogo from '../svg/mojafin';

const { Header, Footer, Content } = Layout;
const { Text } = Typography;

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          position: "fixed",
          zIndex: 1,
          width: "100%",
          backgroundColor: "#FFFFFF",
          padding: '0 50px',
        }}
      >
        <Row justify="space-between" align="middle">
          <Col>
            <KasakaLogo />
          </Col>
          <Col>
            <Button type="default" style={{ marginRight: 20 }}>
              <a href="/">Home</a>
            </Button>
          </Col>
        </Row>
      </Header>

      <Content
        style={{
          padding: "20px",
          marginTop: 64, // Adjust margin to account for fixed Header
          minHeight: "calc(100vh - 64px - 64px)", // Adjust height to fit Footer
          backgroundColor: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to access this page."
          extra={
            <Button type="primary" onClick={() => navigate('/')}>
              Back Home
            </Button>
          }
        />
      </Content>

      <Footer
        style={{
          backgroundColor: "#FFFFFF",
          padding: "24px 50px",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Text
          style={{ fontSize: 14, color: "rgba(0, 0, 0, 0.45)", flex: 1 }}
        >
          © {new Date().getFullYear()}{" "}
          <a href="https://www.afrocentec.com/">Afrocentec</a>. All rights reserved.
        </Text>
        <Text
          style={{
            fontSize: 14,
            color: "rgba(0, 0, 0, 0.45)",
            display: "inline-flex",
            justifyContent: "flex-end",
          }}
        >
          <MojafinLogo />
        </Text>
      </Footer>
    </Layout>
  );
};

export default Unauthorized;

